export { default as Impact } from "./Impact";
